// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebarLogoContainer__Ub2Pf {
  width: 100%;
  padding: 0 25px;
}

.sidebarLogoAnimationContainer__VpUb8 {
  position: relative;
  transition: height 0.5s ease-in-out;
  cursor: pointer;
}

.logoIcon__JWwZ0 {
  transition: height 0.5s ease-in-out;
}

.sidebarSmallTextLogoContainer__u4hDI {
  width: 46px;
  position: absolute;
  bottom: -30px;
  left: 0;
}
.sidebarSmallTextLogoContainer__u4hDI::before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: #2c2d31;
  position: absolute;
  top: 0;
  left: 0;
  transform: scaleX(1);
  transform-origin: 0%;
  transition: all 0.4s ease-in-out;
  transition-delay: 0.1s;
}
.sidebarSmallTextLogoContainer__u4hDI svg {
  width: 100%;
}
@media (max-width: 850px) {
  .sidebarSmallTextLogoContainer__u4hDI {
    width: 39px;
    left: -2px;
  }
}

.sidebarTextLogoContainer__DSSjj {
  position: absolute;
  top: 50%;
  left: 45px;
  transform: translateY(-50%);
}
@media (max-width: 850px) {
  .sidebarTextLogoContainer__DSSjj svg {
    width: 90px;
  }
}

.hiddenSidebarLogoContainer__CODU8 {
  padding: 0 22px;
}
.hiddenSidebarLogoContainer__CODU8 .logoIcon__JWwZ0 {
  width: 100%;
  height: 100%;
}
.hiddenSidebarLogoContainer__CODU8 .sidebarLogoAnimationContainer__VpUb8 {
  width: 45px;
  height: 34px;
}
@media (max-width: 850px) {
  .hiddenSidebarLogoContainer__CODU8 .sidebarLogoAnimationContainer__VpUb8 {
    width: 34px;
  }
}
.hiddenSidebarLogoContainer__CODU8 .sidebarTextLogoContainer__DSSjj {
  left: 47px;
  display: none;
}
.hiddenSidebarLogoContainer__CODU8 .sidebarSmallTextLogoContainer__u4hDI::before {
  transform: scaleX(0);
  transition-delay: 0;
}
@media (max-width: 850px) {
  .hiddenSidebarLogoContainer__CODU8 {
    padding: 0 14px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/Root/components/SidebarLogo/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,mCAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,mCAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;AAzEF;AA2EE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,oBAAA;EACA,gCAAA;EACA,sBAAA;AAzEJ;AA4EE;EACE,WAAA;AA1EJ;AA6EE;EAxBF;IAyBI,WAAA;IACA,UAAA;EA1EF;AACF;;AA6EA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;AA1EF;AA4EE;EACE;IACE,WAAA;EA1EJ;AACF;;AA8EA;EACE,eAAA;AA3EF;AA6EE;EACE,WAAA;EACA,YAAA;AA3EJ;AA8EE;EACE,WAAA;EACA,YAAA;AA5EJ;AA8EI;EAJF;IAKI,WAAA;EA3EJ;AACF;AA8EE;EACE,UAAA;EACA,aAAA;AA5EJ;AAgFI;EACE,oBAAA;EACA,mBAAA;AA9EN;AAkFE;EA7BF;IA8BI,eAAA;EA/EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.sidebarLogoContainer {\n  width: 100%;\n  padding: 0 25px;\n}\n\n.sidebarLogoAnimationContainer {\n  position: relative;\n  transition: height 0.5s ease-in-out;\n  cursor: pointer;\n}\n\n.logoIcon {\n  transition: height 0.5s ease-in-out;\n}\n\n.sidebarSmallTextLogoContainer {\n  width: 46px;\n  position: absolute;\n  bottom: -30px;\n  left: 0;\n\n  &::before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    background-color: #2c2d31;\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: scaleX(1);\n    transform-origin: 0%;\n    transition: all 0.4s ease-in-out;\n    transition-delay: 0.1s;\n  }\n\n  svg {\n    width: 100%;\n  }\n\n  @media (max-width: 850px) {\n    width: 39px;\n    left: -2px;\n  }\n}\n\n.sidebarTextLogoContainer {\n  position: absolute;\n  top: 50%;\n  left: 45px;\n  transform: translateY(-50%);\n\n  @media (max-width: 850px) {\n    svg {\n      width: 90px;\n    }\n  }\n}\n\n.hiddenSidebarLogoContainer {\n  padding: 0 22px;\n\n  .logoIcon {\n    width: 100%;\n    height: 100%;\n  }\n\n  .sidebarLogoAnimationContainer {\n    width: 45px;\n    height: 34px;\n\n    @media (max-width: 850px) {\n      width: 34px;\n    }\n  }\n\n  .sidebarTextLogoContainer {\n    left: 47px;\n    display: none;\n  }\n\n  .sidebarSmallTextLogoContainer {\n    &::before {\n      transform: scaleX(0);\n      transition-delay: 0;\n    }\n  }\n\n  @media (max-width: 850px) {\n    padding: 0 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarLogoContainer": `sidebarLogoContainer__Ub2Pf`,
	"sidebarLogoAnimationContainer": `sidebarLogoAnimationContainer__VpUb8`,
	"logoIcon": `logoIcon__JWwZ0`,
	"sidebarSmallTextLogoContainer": `sidebarSmallTextLogoContainer__u4hDI`,
	"sidebarTextLogoContainer": `sidebarTextLogoContainer__DSSjj`,
	"hiddenSidebarLogoContainer": `hiddenSidebarLogoContainer__CODU8`
};
module.exports = ___CSS_LOADER_EXPORT___;
